import type { ThemeV3 } from '../types/themeTypes';

/** Neutral outer background and inset content surfaces with a muted blue accent. */
export const macroDarkTheme = {
  id: 'Macro Dark',
  name: 'Macro Dark',
  version: 3,
  mode: 'dark',
  colorTokens: {
    'surface-0': '#0e0e0e',
    'surface-1': '#121212',
    'surface-2':
      'color-mix(in oklch, var(--color-surface-0) 95%, var(--color-content-0))',
    'surface-3':
      'color-mix(in oklch, var(--color-surface-0) 93%, var(--color-content-0))',
    'surface-4':
      'color-mix(in oklch, var(--color-surface-0) 91%, var(--color-content-0))',
    'content-0': 'oklch(1 0 21deg)',
    'content-1': 'oklch(0.83 0 21deg)',
    'content-2': 'oklch(0.75 0 21deg)',
    'content-3': 'oklch(0.63 0 21deg)',
    'content-4': 'oklch(0.55 0 21deg)',
    edge: 'var(--color-surface-4)',
    'edge-muted': 'var(--color-surface-2)',
    accent: 'oklch(0.7 0.12 250deg)',
    red: 'oklch(0.75 0.2 25.331deg)',
    orange: 'oklch(0.75 0.2 47.604deg)',
    amber: 'oklch(0.75 0.2 70.08deg)',
    yellow: 'oklch(0.75 0.2 86.047deg)',
    lime: 'oklch(0.75 0.2 130.85deg)',
    green: 'oklch(0.75 0.2 149.579deg)',
    teal: 'oklch(0.75 0.2 182.503deg)',
    cyan: 'oklch(0.75 0.2 215.221deg)',
    blue: 'oklch(0.75 0.2 259.815deg)',
    violet: 'oklch(0.75 0.2 292.717deg)',
    purple: 'oklch(0.75 0.2 303.9deg)',
    pink: 'oklch(0.75 0.2 354.308deg)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': 'var(--color-accent)',
    'link-visited': 'var(--color-accent)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'var(--color-control)',
    'input-focus': 'var(--color-control)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-amber)',
    failure: 'var(--color-red)',
    // Keep mobile glass at its original lightness, independent of the page base.
    chrome: 'oklch(0.2 0 0deg)',
  },
} satisfies ThemeV3;
